<template>
  <div class="entry-menus-search">
    <div class="entry-menus-search__cells" v-if="searchData.length">
      <div
        v-for="item in searchData"
        class="entry-menus-search__cell"
        :class="{ 'entry-menus-search__cell--active': item.key === tabActiveKey }"
        :key="item.key">
        <div class="entry-menus-search__label">
          {{ item | menuLocalName }}
        </div>
        <div class="entry-menus-search__value">
          <a
            v-for="link in item.search"
            :key="link.key"
            href="javascript:;"
            class="entry-menus-search__link"
            style="white-space: nowrap;"
          >
            <div v-html="link.html" @click="handleClick(link.key)" style="display:inline-block;"></div>
            <a-icon v-if="~favoriteKeys.indexOf(link.key)" type="star" theme="filled" style="display:inline-block;color:#5681F4;" @click="delFavorites(link.key)" />
            <a-icon v-else type="star" @click="addFavorites(link.key)" />
          </a>
        </div>
      </div>
    </div>
    <div class="entry-menus-search__empty" v-else>
      <a-empty
        :image="image"
        :description="i18nRender('layouts.text.undefined')"
      />
    </div>
  </div>
</template>

<script>
import EmptyPng from '@/assets/empty.png'
import { filterPane } from '@/store/_util/util'
import { i18nRender } from '@/locales'

export default {
  name: 'EntryMenusSearch',
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    menus: {
      type: Array,
      default () {
        return []
      }
    },
    keyword: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    },
    tabActiveKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      image: EmptyPng
    }
  },
  computed: {
    menusLevel2 () {
      const { menus } = this.$props
      const childMenus = []
      menus.forEach(item => {
        if (item.childMenus.length) {
          // if (item.special === 2) {
          //   item.childMenus.forEach(child => {
          //     child.childMenus.length && childMenus.push(...child.childMenus)
          //   })
          // } else {
            childMenus.push(...item.childMenus)
          // }
        }
      })
      return childMenus
    },
    favoriteKeys () {
      return this.favorites.map(item => item.key)
    },
    searchData () {
      // console.log(filterPane(this.menusLevel2, { tab: '打印机设置', lastMenu: 2, updateFlag: 1 }))
      const { menusLevel2, keyword, currentLang } = this
      const target = keyword.toLowerCase().trim()
      const searchData = menusLevel2.map(item => {
        const childMenus = filterPane(item.childMenus, { lastMenu: 2, updateFlag: 1 })
        const search = childMenus.filter(menu => {
          const menuName = menu.menuName[currentLang] || menu.tab
          return ~menuName.toLowerCase().indexOf(target)
        }).map(menu => {
          const menuName = menu.menuName[currentLang] || menu.tab
          const html = menuName.replace(keyword, `<span style="color:red;">${keyword}</span>`)

          return {
            ...menu,
            html
          }
        })
        // console.log('search', search)
        // const bigMenuName = item.menuName[currentLang] || item.tab
        // const bigMenuSearch = ~bigMenuName.toLowerCase().indexOf(target) && item.updateFlag === 1
        //     ...item,
        //     html: bigMenuName.replace(keyword, `<span style="color:red;">${keyword}</span>`)
        //   } : null
        // console.log('bigMenuSearch', bigMenuSearch)
        return search.length && { ...item, search }
      })
      return searchData.filter(item => item)
    }
  },
  methods: {
    i18nRender,
    handleClick (key) {
      this.$emit('click', key)
    },
    addFavorites (key) {
      this.$store.dispatch('entry/AddFavorites', { key })
        .then(() => {
          this.$notification.success({
            message: this.$t('layouts.bookmarks.success')
          })
        })
    },
    delFavorites (key) {
      this.$store.dispatch('entry/DelFavorites', { key })
        .then(() => {
          this.$notification.success({
            message: this.$t('layouts.bookmarks.cancel')
          })
        })
    }
  }
}
</script>

<style lang="less">
  @namespace: entry-menus-search;

  .@{namespace} {
    height: 100%;
    overflow: auto;

    &__cells {
      padding: 22px;
      font-size: 14px;
      line-height: 2;
    }

    &__cell {
      padding: 22px 0;
      border-top: 1px solid #e8e8e8;
      overflow: hidden;

      &:first-child {
        border-top: none;
      }
    }

    &__cell--active {
      background: #e8e8e8;
    }

    &__label {
      float: left;
      width: 160px;
      padding-left: 8px;
      border-left: 3px solid #5681F4;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__value {
      display: block;
      overflow: hidden;
    }

    &__link {
      margin-right: 5px;
      padding: 0 8px;
      display: inline-block;
      color: #666666;

      .anticon {
        margin-left: 10px;
        display: none;
      }

      &:hover {
        background: rgba(0,0,0,0.1);

        .anticon {
          display: inline-block;
        }
      }
    }
  }

  .@{namespace}__empty {
    margin-top: 100px;
    position: relative;
  }
</style>
